__turbopack_context__.v({
  "closeIcon": "MobileHeader-module__coLQAG__closeIcon",
  "header-mobile__navigation": "MobileHeader-module__coLQAG__header-mobile__navigation",
  "menuButton": "MobileHeader-module__coLQAG__menuButton",
  "mobileFooter": "MobileHeader-module__coLQAG__mobileFooter",
  "mobileNavigation": "MobileHeader-module__coLQAG__mobileNavigation",
  "mobileNavigationContent": "MobileHeader-module__coLQAG__mobileNavigationContent",
  "mobileNavigationOpen": "MobileHeader-module__coLQAG__mobileNavigationOpen",
  "mobileOverlay": "MobileHeader-module__coLQAG__mobileOverlay",
  "mobileOverlayOpen": "MobileHeader-module__coLQAG__mobileOverlayOpen",
});
